// Swiper初期化関数
let initAttempts = 0;
const maxAttempts = 100; // 最大5秒間試行
function initSwiper() {
    initAttempts++;

    if (typeof Swiper === 'undefined') {
        if (initAttempts < maxAttempts) {
            // より短い間隔（20ms）で再試行
            requestAnimationFrame(initSwiper);
        }
        return;
    }

    const swiperElements = document.querySelectorAll('.swiper');
    if (!swiperElements.length) return;

    swiperElements.forEach((swiperElement, index) => {
        // 既に初期化済みの場合はスキップ
        if (swiperElement.swiper) return;

        // 各Swiperインスタンスに固有のクラスを追加
        const uniqueClass = `swiper-${index}`;
        swiperElement.classList.add(uniqueClass);

        new Swiper(`.${uniqueClass}`, {
            direction: 'horizontal',
            loop: true,
            slidesPerView: 1.3,
            spaceBetween: 28,
            centeredSlides: true,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            pagination: {
                el: swiperElement.querySelector('.swiper-pagination'),
                clickable: true,
            },
            navigation: {
                nextEl: swiperElement.querySelector('.swiper-button-next'),
                prevEl: swiperElement.querySelector('.swiper-button-prev'),
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                    spaceBetween: 8,
                    centeredSlides: false,
                },
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 16,
                    centeredSlides: false,
                },
                1200: {
                    slidesPerView: 4,
                    spaceBetween: 24,
                    centeredSlides: false,
                }
            }
        });
    });
}

// 即座に実行開始
initSwiper();

// バックアップとして複数のタイミングでも実行
document.addEventListener('DOMContentLoaded', initSwiper);
window.addEventListener('load', initSwiper);